import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpurandar() {



  const cardData =
  {
    keyword: 'Corporate Cab Service in Purandar Airport',
    heading: 'Sanavi Travels: Corporate Cab Service in Purandar Airport',
    headingDescription: 'Sanavi Travels offers reliable Corporate Cab Service in Purandar Airport, providing safe, comfortable, and professional transportation for business executives, corporate teams, and VIP travelers. Our fleet of well-maintained sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free travel experience. With experienced chauffeurs, flexible one-way and round-trip corporate cab packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Purandar Airport, Pune, and nearby areas, making it ideal for airport transfers, business meetings, corporate events, and client visits. Choose Sanavi Travels for trusted corporate cab services in Purandar Airport, delivering comfort, safety, and a seamless travel experience for every professional journey.',

    top: 'Top Places to Visit in Purandar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Purandar Fort",
    "description": "Purandar Fort is a majestic hill fort located in Pune district, steeped in Maratha history. It is famously associated with Chhatrapati Shivaji Maharaj, who used it as a strategic military base. The fort is divided into two parts – Old Purandar and New Purandar – and offers panoramic views of the Sahyadri ranges, valleys, and surrounding villages. Its ancient gates, temples, and bastions attract history enthusiasts, trekkers, and photographers alike."
  },
  {
    "title": "Mahalaxmi Temple at Purandar",
    "description": "The fort complex houses the Mahalaxmi Temple, a spiritual center for devotees. Pilgrims visiting the fort often offer prayers here, combining spiritual exploration with trekking and sightseeing. The temple’s serene ambiance amidst the fort’s historic ruins adds to the cultural richness of the visit."
  },
  {
    "title": "Trekking Routes to Purandar Fort",
    "description": "Purandar Fort is one of the most popular trekking destinations near Pune. Trekkers can choose multiple routes from nearby villages like Saswad, Purandar, and Bhuleshwar. The trails pass through lush greenery, streams, and rocky terrain, making it ideal for adventure enthusiasts and nature lovers."
  },
  {
    "title": "Jafarabad Fort",
    "description": "Located within the Purandar region, Jafarabad Fort is part of the historical network of forts used by the Marathas. It offers a glimpse into military architecture, strategic watchtowers, and panoramic hilltop views that complement the Purandar trekking experience."
  },
  {
    "title": "Purandar Taluka Villages",
    "description": "The villages surrounding Purandar Fort reflect authentic rural Maharashtrian life, with farms, traditional houses, and local markets. Visitors can experience the cultural fabric of the region, local festivals, and farm-to-table cuisine."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "Bhuleshwar Temple, situated near Purandar, is an ancient temple dedicated to Lord Shiva. Its architecture, carvings, and tranquil surroundings attract both devotees and tourists seeking spiritual solace amidst nature."
  },
  {
    "title": "Monsoon Waterfalls",
    "description": "During the monsoon, the Purandar region comes alive with seasonal waterfalls, flowing streams, and mist-covered hills. These natural sights offer refreshing stops during treks and enhance the scenic beauty of the fort and surrounding landscapes."
  },
  {
    "title": "Historical Plaques and Exhibits",
    "description": "Purandar Fort features several plaques, inscriptions, and remnants of Maratha-era architecture, providing historical context for visitors interested in learning about battles, fortifications, and local legends."
  },
  {
    "title": "Sunrise and Sunset Points",
    "description": "The fort’s elevated vantage points offer spectacular sunrise and sunset views. Photographers and travelers alike flock here to capture the golden light over the Sahyadri hills, the valleys below, and the distant villages."
  },
  {
    "title": "Nature Walks and Birdwatching",
    "description": "The forested areas around Purandar Fort are home to a variety of birds and wildlife. Nature enthusiasts can enjoy walks, photography, and birdwatching while exploring the natural beauty surrounding the historic fort."
  }
]
,



"services": [
{
"name": "Corporate Cab Service in Purandar Airport",
"description": "Corporate Cab Service in Purandar Airport provides professional, reliable, and comfortable taxi services tailored for business travelers. With well-maintained vehicles, experienced drivers, and flexible scheduling, it ensures smooth airport transfers, client pickups, and corporate travel. Ideal for executives, employees, and corporate groups, this service emphasizes punctuality, safety, and efficiency for all business-related travel needs."
},
{
"name": "Corporate Taxi Purandar Airport",
"description": "Corporate Taxi Purandar Airport offers dedicated and efficient taxi services for employees and business travelers commuting to and from Purandar Airport. With spacious vehicles, professional drivers, and seamless scheduling, it ensures timely pickups and drops for corporate meetings, airport transfers, and business trips, delivering a stress-free and comfortable travel experience."
},
{
"name": "AC Corporate Cab Airport",
"description": "AC Corporate Cab Airport provides air-conditioned, comfortable, and well-equipped vehicles for corporate clients traveling to or from Purandar Airport. Designed for long-distance trips, client pickups, and business commuting, it offers a premium travel experience with smooth rides, professional drivers, and timely service."
},
{
"name": "Employee Transport Cab Airport",
"description": "Employee Transport Cab Airport specializes in transporting corporate employees efficiently between Purandar Airport and office locations. With scheduled pickups, well-maintained vehicles, and courteous drivers, it ensures safe, punctual, and comfortable transportation for daily commuting, business trips, and corporate events."
},
{
"name": "Business Travel Cab Purandar",
"description": "Business Travel Cab Purandar caters to executives, business travelers, and corporate teams requiring seamless travel solutions to and from Purandar Airport. Equipped with modern vehicles and professional drivers, it ensures timely arrivals, comfortable rides, and hassle-free airport transfers for important business engagements."
},
{
"name": "Affordable Corporate Cab Airport",
"description": "Affordable Corporate Cab Airport offers budget-friendly yet professional taxi services for corporate clients traveling to and from Purandar Airport. It combines economical pricing with well-maintained vehicles, courteous drivers, and punctual service, making it ideal for companies seeking reliable corporate transport without compromising on quality."
},
{
"name": "Chauffeur Driven Corporate Cab",
"description": "Chauffeur Driven Corporate Cab provides professional drivers who handle navigation, traffic, and schedules, allowing executives and employees to focus on work or relax during travel. Perfect for VIP clients, corporate teams, and business travelers, it ensures a smooth, stress-free, and safe journey to and from Purandar Airport."
},
{
"name": "Best Corporate Cab Airport",
"description": "Best Corporate Cab Airport is recognized for its punctuality, well-maintained vehicles, and excellent customer service. It provides reliable and comfortable airport transfers, office pickups, and business travel solutions, ensuring corporate clients experience seamless, safe, and professional transportation every time."
},
{
"name": "Office Pickup Drop Airport",
"description": "Office Pickup Drop Airport offers scheduled and on-demand cab services for employees traveling between Purandar Airport and office locations. With professional drivers, comfortable vehicles, and reliable service, it ensures timely arrivals and departures for corporate staff, meetings, and business trips."
},
{
"name": "IT Company Cab Airport",
"description": "IT Company Cab Airport provides specialized transportation solutions for IT companies and corporate offices requiring efficient airport transfers for employees and clients. With spacious vehicles, professional drivers, and coordinated scheduling, it guarantees safe, punctual, and convenient travel."
},
{
"name": "Online Cab Booking Airport",
"description": "Online Cab Booking Airport enables corporate clients and employees to book airport cabs quickly and conveniently with instant confirmation. Multiple vehicle options, transparent pricing, and flexible scheduling make corporate travel planning seamless and hassle-free in Purandar Airport and surrounding areas."
},
{
"name": "Long Term Corporate Cab",
"description": "Long Term Corporate Cab offers subscription-based or long-term cab services for businesses needing daily airport transfers, office commutes, and employee transportation. Professional drivers, reliable vehicles, and flexible plans ensure efficient, cost-effective, and comfortable corporate travel solutions."
},
{
"name": "Airport Corporate Transport",
"description": "Airport Corporate Transport provides end-to-end transportation services for corporate clients traveling to and from Purandar Airport. With well-maintained cabs, experienced drivers, and timely service, it ensures a professional, comfortable, and reliable travel experience for executives and business teams."
},
{
"name": "Purandar Airport Cab Service",
"description": "Purandar Airport Cab Service delivers premium and dependable taxi solutions for airport pickups, drops, and corporate travel. Combining comfort, safety, and punctuality, it caters to executives, employees, and corporate groups seeking seamless airport transportation in Purandar."
},
{
"name": "Executive Cab Airport",
"description": "Executive Cab Airport offers luxury and professional cabs for VIPs, corporate executives, and business travelers. With comfortable seating, air-conditioning, professional drivers, and timely service, it ensures a smooth, stress-free, and premium travel experience to and from Purandar Airport."
}
],
"tableData": [
["Corporate Cab Service in Purandar Airport", "Corporate Taxi Purandar Airport"],
["AC Corporate Cab Airport", "Employee Transport Cab Airport"],
["Business Travel Cab Purandar", "Affordable Corporate Cab Airport"],
["Chauffeur Driven Corporate Cab", "Best Corporate Cab Airport"],
["Office Pickup Drop Airport", "IT Company Cab Airport"],
["Online Cab Booking Airport", "Long Term Corporate Cab"],
["Airport Corporate Transport", "Purandar Airport Cab Service"],
["Executive Cab Airport", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Purandar Airport with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers premium corporate cab services at Purandar Airport, designed for business travelers, executives, and corporate groups with a focus on comfort, professionalism, and punctuality."
  },
  {
    "WhyChooseheading": "Professional and Well‑Maintained Vehicles",
    "WhyChoosedescription": "Our fleet of clean, air‑conditioned cabs includes executive and premium options to ensure a smooth and comfortable ride for corporate clients."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our licensed drivers are trained in professional etiquette, familiar with Purandar Airport routes, and committed to safe and timely travel for your corporate needs."
  },
  {
    "WhyChooseheading": "Transparent Corporate Pricing",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for corporate cab services at Purandar Airport, with no hidden charges, tailored to business travel requirements."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support",
    "WhyChoosedescription": "Our customer support team is available around the clock to help with bookings, itinerary changes, and corporate travel assistance."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from scheduled pickups, airport arrival plans, hourly corporate cab rentals, and customized packages to match your business itinerary."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Cabs",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for corporate passengers."
  },
  {
    "WhyChooseheading": "Punctual and Reliable Service",
    "WhyChoosedescription": "We guarantee on‑time pickups and dependable service, making Sanavi Travels a trusted choice for corporate cab needs at Purandar Airport."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer corporate cab services at Purandar Airport?',
    answer: 'Yes, Sanavi Travels provides reliable and professional corporate cab services at Purandar Airport tailored for business travelers.'
  },
  {
    question: 'How can I book a corporate cab at Purandar Airport?',
    answer: 'You can book a corporate cab through our website, by email, or by contacting our dedicated 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for corporate travel?',
    answer: 'Sanavi Travels offers a range of vehicles including executive sedans, SUVs, and premium cab options for corporate clients.'
  },
  {
    question: 'Are the drivers experienced and professional?',
    answer: 'Yes, our drivers are licensed, courteous, and trained to offer professional service for corporate travelers.'
  },
  {
    question: 'Can I schedule pickups in advance?',
    answer: 'Absolutely — you can schedule pickups in advance to match your flight arrival or corporate itinerary.'
  },
  {
    question: 'Is corporate cab service available 24x7?',
    answer: 'Yes, our corporate cab services at Purandar Airport are available round‑the‑clock to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all corporate cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic experience.'
  },
  {
    question: 'What payment methods are accepted?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate invoicing for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your corporate cab service.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Verma',
    feedback: 'Sanavi Travels provided excellent corporate cab service at Purandar Airport — professional drivers, comfortable ride, and punctual arrival.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Highly recommended for business travel from Purandar Airport. The corporate cab service was prompt and efficient!',
    rating: 5
  }
];





















































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Corporate Cab Service in Purandar Airport - Sanavi Travels",
  "description": "Sanavi Travels provides professional corporate cab services in Purandar Airport. AC and chauffeur-driven cabs available for employee transport, business travel, office pickup/drop, long-term corporate rentals, and airport transfers. Book online 24x7.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "38"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Corporate Cab Service in Purandar Airport | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book professional corporate cab service in Purandar Airport with Sanavi Travels. AC and chauffeur-driven taxis for employee transport, office pickups, business travel, and long-term corporate rentals. 24x7 online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/142.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpurandar;